import { IHighlightSortingParams } from './useQueryHighlights';

export const BASE_KEY = 'HIGHLIGHTS';

export const highlightKeys = {
  all: () => [BASE_KEY] as const,
  list: (params: IHighlightSortingParams) => [BASE_KEY, params] as const,
  details: () => [BASE_KEY, 'detail'] as const,
  detail: (id: string | number) => [BASE_KEY, 'detail', id] as const,
};
